import { render, staticRenderFns } from "./ActiveEvent.vue?vue&type=template&id=ffc872fe&scoped=true&"
import script from "./ActiveEvent.vue?vue&type=script&lang=js&"
export * from "./ActiveEvent.vue?vue&type=script&lang=js&"
import style0 from "./ActiveEvent.vue?vue&type=style&index=0&id=ffc872fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc872fe",
  null
  
)

export default component.exports